import React from 'react';
import { CheckCircleIcon } from 'lucide-react';
export function ProductShowcase() {
  return <section className="pt-20 pb-8 px-4 bg-brand-light" data-id="element-274">
      <div className="max-w-5xl mx-auto text-center" data-id="element-275">
        <div className="inline-flex items-center justify-center gap-2 bg-yellow-100 text-yellow-800 font-bold px-4 py-2 rounded-full mb-6" data-id="element-276">
          <span data-id="element-277">🏆</span> El sistema N°1 para docentes de Química en Argentina
        </div>

        <h2 className="text-4xl md:text-6xl font-black text-brand-dark mb-4" data-id="element-278">
          🧪 QUÍMICA EN ACCIÓN
        </h2>
        <h3 className="text-3xl md:text-4xl font-extrabold text-brand-blue mb-8" data-id="element-279">
          MEGAPACK QUÍMICA EN ACCIÓN
        </h3>

        <p className="text-xl text-gray-700 max-w-3xl mx-auto mb-12" data-id="element-280">
          5 cuadernillos organizados por año. +600 páginas con actividades,
          rúbricas y experiencias. 6 bonos estratégicos. Todo listo para usar
          desde hoy.
        </p>

        <div className="flex flex-wrap justify-center gap-4 mb-12" data-id="element-281">
          {['1°', '2°', '3°', '4°', '5°'].map(year => <div key={year} className="w-16 h-16 bg-white rounded-xl shadow-md flex items-center justify-center text-2xl font-black text-brand-blue border-2 border-brand-blue/10" data-id="element-282">
              {year}
            </div>)}
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-283">
          <div className="text-left bg-white p-8 rounded-2xl shadow-xl" data-id="element-284">
            <h4 className="text-2xl font-black text-brand-dark mb-6 border-b pb-4" data-id="element-285">
              5 CUADERNILLOS COMPLETOS
            </h4>
            <ul className="space-y-4" data-id="element-286">
              {['Por año', 'Con actividades secuenciadas', 'Con rúbricas integradas', 'Con bonos'].map((item, i) => <li key={i} className="flex items-center gap-3 text-xl font-bold text-gray-800" data-id="element-287">
                  <CheckCircleIcon className="w-8 h-8 text-brand-green flex-shrink-0" data-id="element-288" />
                  {item}
                </li>)}
            </ul>
          </div>

          <div data-id="element-289">
            <a href="#compra" className="block cursor-pointer transform hover:scale-[1.02] transition-transform duration-300" data-id="element-290">
              <img src="https://cdn.magicpatterns.com/uploads/b9eeoqdPnXXuU46xT6YM7T/MEGA_PACK_BIOLOGIA_EN_ACCION_DE_1°_A_6°_ANO_(4).png" alt="MegaPack Química en Acción" className="w-full drop-shadow-2xl rounded-xl" data-id="element-291" />
            </a>
          </div>
        </div>
      </div>
    </section>;
}